import { aiActions } from '../actions/aiActions';

const initialState = {
  aiSidebarMode: 'closed',
  selectedChat: null,
  chatHistories: [],
  loading: {
    getChatHistories: false,
    addChat: false,
    deleteChat: false,
  },
  error: {
    getChatHistoriesError: null,
    addChatError: null,
    deleteChatError: null,
  },
};

const aiReducer = (state = initialState, action) => {
  switch (action.type) {
    case aiActions.SET_AI_SIDEBAR_MODE:
      return {
        ...state,
        aiSidebarMode: action.payload,
      };
    case aiActions.GET_CHAT_HISTORIES:
      return {
        ...state,
        loading: {
          ...state.loading,
          getChatHistories: true,
        },
        error: {
          ...state.error,
          getChatHistoriesError: null,
        },
      };
    case aiActions.GET_CHAT_HISTORIES_SUCCESS:
      return {
        ...state,
        chatHistories: action.payload,
        loading: {
          ...state.loading,
          getChatHistories: false,
        },
        error: {
          ...state.error,
          getChatHistoriesError: null,
        },
      };
    case aiActions.ADD_CHAT:
      return {
        ...state,
        loading: {
          ...state.loading,
          addChat: true,
        },
        error: {
          ...state.error,
          addChatError: null,
        },
      };
    case aiActions.ADD_CHAT_SUCCESS:
      return {
        ...state,
        chatHistories: [...state.chatHistories, action.payload],
        loading: {
          ...state.loading,
          addChat: false,
        },
        error: {
          ...state.error,
          addChatError: null,
        },
      };
    case aiActions.ADD_CHAT_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          addChat: false,
        },
        error: {
          ...state.error,
          addChatError: action.payload,
        },
      };

    case aiActions.DELETE_CHAT:
      return {
        ...state,
        loading: {
          ...state.loading,
          deleteChat: true,
        },
        error: {
          ...state.error,
          deleteChatError: null,
        },
      };
    case aiActions.DELETE_CHAT_SUCCESS:
      return {
        ...state,
        chatHistories: state.chatHistories.filter(
          chat => chat.id !== action.payload
        ),
        loading: {
          ...state.loading,
          deleteChat: false,
        },
        error: {
          ...state.error,
          deleteChatError: null,
        },
      };
    case aiActions.DELETE_CHAT_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          deleteChat: false,
        },
        error: {
          ...state.error,
          deleteChatError: action.payload,
        },
      };
    case aiActions.SET_SELECTED_CHAT_HISTORY:
      return {
        ...state,
        selectedChat: action.payload,
      };
    default:
      return state;
  }
};

export default aiReducer;
